var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardBackCvv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8a2 2 0 012-2h24a2 2 0 012 2v16a2 2 0 01-2 2H4a2 2 0 01-2-2V8z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.414 25.414zM29.842 24.779z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 10H2v4h28v-4z",
    fill: "#424143"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 26z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46 17.186h7.88l.892-.637H6.46v.637z",
    fill: "#424143"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.5 15h4v4h-4zM5 15h16v4H5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 17h3v-.6h-3v.6zM6 17h13v-.6H6v.6z",
    fill: "#424143"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.61 19.221c-.338.17-.712.274-1.114.274-.403 0-.778-.104-1.114-.274a2.493 2.493 0 01-1.386-2.225c0-1.378 1.122-2.5 2.5-2.5s2.5 1.122 2.5 2.5c0 .976-.57 1.814-1.386 2.225zM24.496 12.5c-1.42 0-2.674.675-3.498 1.707A4.449 4.449 0 0020 16.995c0 .813.233 1.567.613 2.225a4.479 4.479 0 001.093 1.271c.768.616 1.73.999 2.79.999a4.5 4.5 0 004.496-4.495 4.501 4.501 0 00-4.496-4.496z",
    fill: "#E9564B"
  })));
}

export default SvgIconCreditCardBackCvv;